<!-- 历史数据回溯 -->
<template>
  <div>
    <el-card style="margin-bottom: 20px;">
      <div class="title">
        <p>历史数据回溯</p>
        <div>
          <el-date-picker v-model="value" type="daterange" align="right" unlink-panels range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
          </el-date-picker>
          <el-button type="primary" icon="el-icon-search" style="margin-left: 16px;width: 98px;">搜索</el-button>
          <el-button icon="el-icon-refresh-left" style="margin-left: 16px;width: 98px;">重置</el-button>
        </div>
      </div>
    </el-card>
    <matrix-statistics span="8" :list="statisticsList"></matrix-statistics>

    <el-card>
      <div class="title">
        <p>历史趋势</p>
      </div>
      <div id="trend"></div>
    </el-card>


    <el-card style="height: 500px;margin-top: 20px">
      <div class="title" style="margin-bottom: 10px;">
        <p>明细数据</p>
        <div>
          <el-select v-model="value1" placeholder="全部仓库" style="width: 160px;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="value1" placeholder="全部类型" style="width: 160px;margin-left: 16px;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button type="primary" icon="el-icon-search" style="margin-left: 16px;width: 98px;">搜索</el-button>
          <el-button icon="el-icon-refresh-left" style="margin-left: 16px;width: 98px;">重置</el-button>
        </div>
      </div>
      <avue-crud :data="data" :option="option" :page.sync="page">
      </avue-crud>
    </el-card>
    <div style="height: 80px;"></div>
  </div>
</template>
<script>
import matrixStatistics from '@/components/matrix/matrix-statistics'
import { getDefaultSearchTimeRange, getSearchTimePickerOptions } from '@/basic-common/util/common'
import * as echarts from 'echarts';

export default {
  name: "store-management/index/index",
  components: {
    matrixStatistics
  },
  data() {
    return {
      statisticsList: [{
        label: '选定期间总入库量',
        value: 123456,
        unit: ' 吨',
      }, {
        label: '选定期间总出库量',
        value: 987654,
        unit: ' 吨',
      }, {
        label: '选定期间末库存量',
        value: 42156,
        unit: ' 吨',
      }],
      value: getDefaultSearchTimeRange('daterange'),
      pickerOptions: getSearchTimePickerOptions('daterange'),

      page: {
        pageSize: 10, // 每页显示10条
        currentPage: 1, // 第一页
        total: 3 // 总条数
      },
      data: [{
        name1: '北京仓库',
        name2: 'A 区',
        name3: '无烟煤',
        name4: '42,156 吨',
        name5: '15 天',
        name6: 1,
      }, {
        name1: '上海仓库',
        name2: 'V 区',
        name3: '无烟煤',
        name4: '42,156 吨',
        name5: '15 天',
        name6: 2,
      }, {
        name1: '广州仓库',
        name2: 'D 区',
        name3: '无烟煤',
        name4: '42,156 吨',
        name5: '15 天',
        name6: 3,
      }],
      option: {
        header: false,
        menu:false,
        height: '370px',
        column: [{
          label: '日期',
          prop: 'name1',
          align: 'center'
        }, {
          label: '仓库',
          prop: 'name2',
          align: 'center'
        }, {
          label: '物资类型',
          prop: 'name3',
          align: 'center'
        }, {
          label: '入库量(吨)',
          prop: 'name4',
          align: 'center'
        }, {
          label: '出库量(吨)',
          prop: 'name5',
          align: 'center'
        }, {
          label: '库存量(吨)',
          prop: 'name6',
          align: 'center'
        },]
      },
      value1: '',
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
    };
  },
  mounted() {
    this.trendInit()
  },
  methods: {
    trendInit() {
      let chartDom = document.getElementById('trend');
      let myChart = echarts.init(chartDom);
      let option = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        legend: {
          textStyle: {
            color: '#374151',
            fontSize: 14,
          },
          lineStyle: {
            type: 'solid'
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          splitLine: {
            lineStyle: {
              color: '#e0e6f1'
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#e0e6f1'
            }
          }
        },
        series: [
          {
            name: '库存量',
            data: [820, 932, 1101, 1234, 1290, 1330, 1320, 1101, 1234, 1290, 1330, 1320],
            type: 'line',
            lineStyle: {
              color: '#2563EB',
              width: 2,
            },
            itemStyle: {
              color: '#2563EB',
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0.2,
                  color: 'rgba(37,99,235,0)'
                },
                {
                  offset: 1,
                  color: 'rgba(37,99,235,0.3)'
                }
              ])
            },
          },
        ]
      };
      option && myChart.setOption(option);
    },
  }
};
</script>
<style scoped lang="scss">
#trend{
  width: 100%;
  height: 400px;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    color: #000000;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin: 0;
  }
}

::v-deep .el-input__icon {
  line-height: 1 !important;
}
</style>
